














































































































































































import { ConfirmButton } from '@/app/components';
import { useFilters } from '@/app/composable';
import { WorkflowStatus } from '@/modules/apollo/constants';
import { AssetType, AssetTypeId } from '@/modules/asset/constants';
import AssetTypeIcon from '@/modules/asset/components/AssetTypeIcon.vue';
import { AlertSourceType } from '../constants/alert.constants';
import { computed, defineComponent } from '@vue/composition-api';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { Icon } from '@iconify/vue2';

dayjs.extend(weekOfYear);
dayjs.extend(utc);

export default defineComponent({
    name: 'AlertOverview',
    props: {
        alert: {
            type: Object,
            required: true,
        },
    },
    components: {
        AssetTypeIcon,
        ConfirmButton,
        Icon,
    },
    setup(props: any) {
        const assetClass = (type: string) => {
            switch (type) {
                case AssetType.Result:
                    return 'text-blue-800';
                case AssetType.Model:
                    return 'text-cherry-700';
                default:
                    return 'text-orange-800';
            }
        };

        const { formatDate, formatDateTime } = useFilters();

        const pipeline = computed(() =>
            props.alert?.entities.find(
                (entity: { id: string | number; name: string; type: AlertSourceType; mine: boolean }) =>
                    [AlertSourceType.Analytics, AlertSourceType.DataCheckin].includes(entity.type),
            ),
        );

        const assets = computed(() =>
            props.alert?.entities?.filter(
                (entity: { id: string | number; name: string; type: AlertSourceType; mine: boolean }) =>
                    [AlertSourceType.Dataset, AlertSourceType.Result].includes(entity.type),
            ),
        );

        return {
            WorkflowStatus,
            formatDate,
            formatDateTime,
            dayjs,
            AssetTypeId,
            assetClass,
            pipeline,
            assets,
        };
    },
});
